
























































































































































































































/*
  getTeacherDetailInfo 查看教师详情信息
  saveOrUpdateEnrollInfo 保存或编辑教师信息
*/
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import {
  getTeacherDetailInfo,
  saveOrUpdateEnrollInfo
} from "../../../../api/teacherInfoManage";
import { getToken } from "../../../../utils/auth";
import { validateMax32, validateTeacherAge, blurTeacherAge, ruleNormal, rulePattern,validatePhone } from '@/utils/regxCustom'
//自定义对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "detail"
})
export default class extends Vue {
  @Prop(String) otherinfoProjectId!: string;
  @Prop(String) otherinfoSourceId!: string;
  @Prop(String) teacherId!: string;
  private showExcellentTeacher = false //是否显示优秀教师
  private teacherInfoVo: CustomForm = {}; //详情数据
  private historyEmployInfoVos: CustomForm[] = []; //历次聘用信息表格
  private imageUrl: string = ""; //头像地址
  // 后来添加的上传需要的参数
  private inputCheck: boolean = true; // 查询格式校验是否通过
  private upload = {
    header: {
      Authorization: getToken(),
      access_token: getToken()
    },
    fileList: []
  };
  private fullscreenLoading: boolean = false; //spin toggle

  private formRules: object = {
     teacherName: [
      ruleNormal("请输入姓名"),
      {validator: validateMax32}
    ],
    teacherAge: [ruleNormal("请输入年龄")],
    teacherCard: [
       ruleNormal("请输入身份证号"),
    ],
    teacherTeachingAge: [
      ruleNormal("请输入教龄"),
      { validator: validateTeacherAge },
      { validator: blurTeacherAge, trigger: "blur" }  //教龄
    ],
    teacherPhone: [
       ruleNormal("请输入手机号码"),
         // { validator: validatePhone }
    ],
    teacherSchoolId: [ruleNormal("请选择所属单位")],
    teacherDistrictId: [ruleNormal("请选择所属市县")],
    otherinfoSubject: [ruleNormal("请选择科目")],
    otherinfoHaveRelatives: [ruleNormal("请选择是否近亲或利害关系人高考")],
    otherinfoIntroduction: [ruleNormal("请输入个人简介")],
    teacherPhotoPath: [ruleNormal("请上传相片")]
  };
  created() {
    this.getDetail();
  }

  // 校验科目是否为空
  private subjectCheck(e){
    if (e.length <=0 ) {
      //不满足条件，提醒并获取焦点
      this.$message.warning("科目不能为空");
      this.inputCheck = false;
    } else {
      this.inputCheck = true;
    }
  }

  //上传地址
  get uploadUrl() {
    return (
      window.config.baseUrl4Shool + "/baseinfo/teacherinfo/upLoadHeadImage"
    );
  }

  // 根据选择的市县过滤单位列表
  get filteredSchools(): any[] {
    const schools = (this.$parent as any).schools || [];
    if (!this.teacherInfoVo.teacherDistrictId) {
      return schools;
    }
    return schools.filter((school: any) => school.schoolDistrictId === this.teacherInfoVo.teacherDistrictId);
  }

  // 市县变更时清空单位选择
  private handleDistrictChange() {
    this.teacherInfoVo.teacherSchoolId = '';
  }

  //获取详情数据
  private async getDetail() {
    try {
      let res = await getTeacherDetailInfo({
        otherinfoProjectId: this.otherinfoProjectId,
        otherinfoSourceId: this.otherinfoSourceId,
        teacherId: this.teacherId
      });
      this.teacherInfoVo = res.data.teacherInfoVo;
      if(this.teacherInfoVo.base64String){
      this.imageUrl ='data:image/jpeg;base64,'+this.teacherInfoVo.base64String;
        // window.config.baseUrl4Shool + this.teacherInfoVo.teacherPhotoPath;
      }
      this.historyEmployInfoVos = res.data.historyEmployInfoVos;
    } catch (error) {
      this.$message.error(error || "获取详情失败");
    }
  }

  private handleAvatarSuccess(res: any) {
    try {
      if (res.code != "20000000") {
        // this.$message.error(res.mesg);
        this[`$message`]({
          type: "error",
          message: res!.mesg ? res!.mesg : res
        });
      }
      this.teacherInfoVo.teacherPhotoPath = res.data.teacherPhotoPath;
      this.imageUrl ='data:image/jpeg;base64,'+res.data.base64String
        // window.config.baseUrl4Shool + this.teacherInfoVo.teacherPhotoPath;
      this.$forceUpdate();
    } catch (error) {
      // this.$message.error(error || "上传失败！");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private beforeAvatarUpload(file: any) {
    const isJPG = file.type === "image/jpeg";
    const isJPG2 = file.type === "image/jpg";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG || isJPG2) {
      this.$message.error("上传头像图片只能是 JPG 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  //保存处理
  private async saveHandle() {
    let formDom: any = this.$refs['teacherInfoVo'];
    let valid = await formDom.validate();
    if(!valid) return false
    if(!this.inputCheck){
      this.$message.warning("科目不能为空");
      return
    }
    let params = {
      otherinfoIntroduction: this.teacherInfoVo.otherinfoIntroduction, //简介
      otherinfoIsExcellentTeacher: this.teacherInfoVo.otherinfoIsExcellentTeacher, //是否优秀教师 0:是 1:否
      otherinfoIsRecommend: this.teacherInfoVo.otherinfoIsRecommend, //是否推荐 0:推荐, 1:不推荐
      otherinfoProjectId: this.teacherInfoVo.projectId, //项目id
      otherinfoSourceId: this.teacherInfoVo.otherinfoSourceId, //来源id
      otherinfoSubject: this.teacherInfoVo.subjectId, //科目
      teacherAddress: this.teacherInfoVo.teacherAddress, //地址
      teacherAge: this.teacherInfoVo.teacherAge, //年龄
      teacherBirthday: this.teacherInfoVo.teacherBirthday, //出生年日
      teacherCard: this.teacherInfoVo.teacherCard, //身份证号
      teacherDistrictId: this.teacherInfoVo.teacherDistrictId, //市县id
      teacherEmail: this.teacherInfoVo.teacherEmail, //邮箱
      teacherGenderId: this.teacherInfoVo.teacherGenderId, //性别id
      teacherGradeId: this.teacherInfoVo.teacherGradeId, //任课年级
      teacherId: this.teacherInfoVo.teacherId, //教师信息id
      teacherName: this.teacherInfoVo.teacherName, //教师姓名
      teacherPhone: this.teacherInfoVo.teacherPhone, //手机号
      teacherPhotoPath: this.teacherInfoVo.teacherPhotoPath, //头像路径
      teacherProfessionalId: this.teacherInfoVo.teacherProfessionalId, //职称
      teacherSchoolId: this.teacherInfoVo.teacherSchoolId, //所属学校id (单位)
      teacherTeachingAge: this.teacherInfoVo.teacherTeachingAge, //教龄
      otherinfoLastMarkingTimes: this.teacherInfoVo.otherinfoLastMarkingTimes, //最近三年参加同类考试评卷次数
      otherinfoHaveRelatives: this.teacherInfoVo.otherinfoHaveRelatives, //是否近亲或利害关系人参加同类考试
      otherinfoRecommendRole: this.teacherInfoVo.otherinfoRecommendRole, //推荐岗位
    };
    // TODO：还缺少 开户行、银行卡号
    try {
      this.fullscreenLoading = true;
      await saveOrUpdateEnrollInfo(params);
      this.fullscreenLoading = false;
      this.$message.success("保存成功");
    } catch (error) {
      this.fullscreenLoading = false;
      // this.$message.error(error || "保存失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //返回处理：回传当前项目/来源，使列表页保留筛选条件
  @Emit("otherinfoChange")
  private backHandle() {
    (this.$parent as any).showDetail = false;
    return { projectId: this.otherinfoProjectId, sourceId: this.otherinfoSourceId };
  }
}
